import { useCallback } from 'react';
import { InformationBox, Loader } from '@app/core';
import {
  Participant,
  useCurrentParticipant,
  useVerifyEmailValidationCode,
} from '@app/api';
import { CodeVerificationContent } from './CodeVerificationContent';
import { useTranslation } from 'react-i18next';

interface Props {
  onSuccess?: (participant: Participant) => any;
  displayed?: boolean;
  email?: string;
  participantId?: string;
  text?: string;
  sentText?: string;
}

export const VerifyEmailViaCodeContent = ({
  onSuccess,
  email,
  displayed,
  participantId,
  text,
  sentText,
}: Props) => {
  const { t } = useTranslation('common');
  const { data: participant, isLoading: isLoadingParticipant } =
    useCurrentParticipant();

  const {
    mutateAsync: verifyEmail,
    isLoading,
    error,
  } = useVerifyEmailValidationCode(participant?.id);

  const submit = useCallback(
    async (accountId: string, code: string) => {
      const participant = await verifyEmail({
        accountId,
        code,
      });
      onSuccess && participant && onSuccess(participant);
    },
    [onSuccess, verifyEmail],
  );

  if (!email) {
    return <InformationBox title={t('toast.genericError')} variant="danger" />;
  }

  if (isLoadingParticipant) {
    return <Loader />;
  }

  if (!participant) {
    return null;
  }

  return (
    <CodeVerificationContent
      hideTitle
      error={error}
      verifiedMethod={submit}
      displayed={displayed}
      participantId={participantId}
      text={text}
      email={email}
      isLoading={isLoading}
      sentText={sentText}
    />
  );
};
